<template>
  <v-flex>
    <v-card class="max-shadow">
      <v-card-title>
        <div class="title-2">Modules</div>
      </v-card-title>
      <v-divider />
      <v-list dense class="pa-3">
        <v-list-tile class="pb-3">
          <v-list-tile-action>
            <v-icon>mdi-dumbbell</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-content class="subheading">Meeting Rooms</v-list-tile-content>
            <v-list-tile-content
              class="caption"
            >{{ this.meetingRooms ? "Disable" : "Enable" }} meeting room module</v-list-tile-content>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch
              v-model="meetingRooms"
              :loading="mLoading"
              :disabled="mLoading"
              color="primary"
            />
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>headset_mic</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-content class="subheading">Help Desk</v-list-tile-content>
            <v-list-tile-content
              class="caption"
            >{{ this.helpDesk ? "Disable" : "Enable" }} help desk module</v-list-tile-content>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch v-model="helpDesk" :loading="hLoading" :disabled="hLoading" color="primary" />
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-flex>
</template>
<script>
import { firestore } from '@/firebase';

export default {
  name: 'ModuleSettings',
  props: {
    tenantId: {
      type: String,
      required: true
    }
  },
  computed: {
    tenantRef() {
      return firestore.doc(`tenants/${this.tenantId}`);
    }
  },
  data() {
    return {
      tenant: {
        modules: {}
      },
      mLoading: false,
      hLoading: false,
      meetingRooms: false,
      helpDesk: false
    };
  },
  watch: {
    meetingRooms: {
      handler(val) {
        this.mLoading = true;
        this.tenantRef
          .update({
            'modules.meetingRooms': val
          })
          .then(val => {
            this.mLoading = false;
          });
      },
      deep: true
    },
    helpDesk: {
      handler(val) {
        this.hLoading = true;
        this.tenantRef
          .update({
            'modules.helpDesk': val
          })
          .then(val => {
            this.hLoading = false;
          });
      },
      deep: true
    }
  },
  mounted() {
    // fetch tenant details
    this.tenantRef.get().then(tenantSnapshot => {
      this.tenant = tenantSnapshot.data();
      this.meetingRooms = (this.tenant.modules || {}).meetingRooms || false;
      this.helpDesk = (this.tenant.modules || {}).helpDesk || false;
    });
  }
};
</script>